export default __webpack_public_path__ + "static/media/ghost.829d5337.png";